(function () {
  function clamp(v, min, max) {
    return Math.max(min, Math.min(max, v));
  }

  function initSection(wrap) {
    var sticky = wrap.querySelector('.lq-sticky');
    var svg = wrap.querySelector('[data-lq-streams]');
    var dripsLayer = wrap.querySelector('[data-lq-drips]');
    var bottleEls = Array.prototype.slice.call(wrap.querySelectorAll('[data-lq-bottle]'));
    var vialMouth = wrap.querySelector('[data-vial-mouth]');
    var stages = Array.prototype.slice.call(wrap.querySelectorAll('[data-lq-stage]'));

    // Données des bouteilles lues une seule fois (et pas à chaque frame de scroll)
    var bottles = bottleEls.map(function (bottleEl) {
      return {
        tiltWrap: bottleEl.querySelector('[data-lq-bottle-tilt]'),
        delay: (parseFloat(bottleEl.getAttribute('data-pour-delay')) || 0) / 100,
        sign: (parseFloat(bottleEl.getAttribute('data-rotation')) || 0) < 0 ? -1 : 1,
        lastTilt: null
      };
    });

    var streams = [];
    var ticking = false;
    var isVisible = false;
    var builtWidth = 0;
    var builtHeight = 0;
    var lastProgress = -1;

    function buildStreams() {
      streams = [];
      if (dripsLayer) dripsLayer.innerHTML = '';
      if (!vialMouth || !svg || !sticky) return;

      var rect = sticky.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      builtWidth = rect.width;
      builtHeight = rect.height;
      svg.setAttribute('viewBox', '0 0 ' + rect.width + ' ' + rect.height);

      var mouthRect = vialMouth.getBoundingClientRect();
      var mouthX = mouthRect.left + mouthRect.width / 2 - rect.left;
      var mouthY = mouthRect.top + mouthRect.height / 2 - rect.top;

      bottleEls.forEach(function (bottleEl, i) {
        var pourPoint = bottleEl.querySelector('[data-pour-point]');
        var pathEl = svg.querySelector('[data-lq-stream][data-bottle-index="' + i + '"]');
        if (!pourPoint || !pathEl) return;

        var pr = pourPoint.getBoundingClientRect();
        var startX = pr.left + pr.width / 2 - rect.left;
        var startY = pr.top + pr.height / 2 - rect.top;

        // Parabolic pour arc: bulges outward/upward from the straight line
        // between the spout and the vial mouth, like a real poured stream.
        var dx = mouthX - startX;
        var dy = mouthY - startY;
        var dist = Math.sqrt(dx * dx + dy * dy) || 1;
        var bulge = Math.max(60, dist * 0.4);
        var px = -dy / dist;
        var py = dx / dist;
        if (py > 0) { px = -px; py = -py; }
        var c1x = startX + dx * 0.3 + px * bulge;
        var c1y = startY + dy * 0.3 + py * bulge;
        var c2x = startX + dx * 0.68 + px * bulge * 0.55;
        var c2y = startY + dy * 0.68 + py * bulge * 0.55;

        var d = 'M ' + startX.toFixed(1) + ' ' + startY.toFixed(1) +
          ' C ' + c1x.toFixed(1) + ' ' + c1y.toFixed(1) + ', ' +
          c2x.toFixed(1) + ' ' + c2y.toFixed(1) + ', ' +
          mouthX.toFixed(1) + ' ' + mouthY.toFixed(1);
        pathEl.setAttribute('d', d);

        var length = 0;
        try {
          length = pathEl.getTotalLength();
        } catch (e) {
          length = 0;
        }
        pathEl.style.strokeDasharray = length;
        pathEl.style.strokeDashoffset = length;

        var drips = [];
        if (length > 0) {
          [0.35, 0.7].forEach(function (frac) {
            var el = document.createElement('span');
            el.className = 'lq-drip';
            var pt = pathEl.getPointAtLength(length * frac);
            el.style.top = pt.y + 'px';
            el.style.left = pt.x + 'px';
            if (dripsLayer) dripsLayer.appendChild(el);
            drips.push(el);
          });
        }

        streams.push({
          path: pathEl,
          length: length,
          delay: bottles[i].delay,
          drips: drips,
          lastOffset: null,
          dripsActive: false
        });
      });
    }

    function setDripsActive(s, active) {
      if (s.dripsActive === active) return;
      s.dripsActive = active;
      s.drips.forEach(function (drip) {
        drip.classList.toggle('is-active', active);
      });
    }

    function update(force) {
      ticking = false;
      var rect = wrap.getBoundingClientRect();
      // Hauteur du bloc sticky (stable) plutôt que window.innerHeight, qui varie
      // sur iPhone quand la barre d'adresse de Safari apparaît/disparaît.
      var total = wrap.offsetHeight - sticky.offsetHeight;
      var progress = total > 0 ? clamp(-rect.top / total, 0, 1) : 0;
      // Rien n'a bougé depuis la dernière image : on ne réécrit rien dans le DOM
      if (force !== true && Math.abs(progress - lastProgress) < 0.0004) return;
      lastProgress = progress;

      streams.forEach(function (s) {
        if (!s.length) return;
        var span = 1 - s.delay;
        var local = span > 0 ? clamp((progress - s.delay) / span, 0, 1) : 0;
        // Arrondi au pixel : évite de redessiner les filets pour des écarts invisibles
        var offset = Math.round(s.length * (1 - local));
        if (offset !== s.lastOffset) {
          s.lastOffset = offset;
          s.path.style.strokeDashoffset = offset;
        }
        setDripsActive(s, isVisible && local > 0.04);
      });

      var tiltLead = 0.18;
      var tiltAmount = 18;
      bottles.forEach(function (b) {
        if (!b.tiltWrap) return;
        var tiltStart = Math.max(0, b.delay - tiltLead);
        var tiltLocal = clamp((progress - tiltStart) / tiltLead, 0, 1);
        var eased = tiltLocal * tiltLocal * (3 - 2 * tiltLocal);
        var tilt = (b.sign * tiltAmount * eased).toFixed(1);
        if (tilt !== b.lastTilt) {
          b.lastTilt = tilt;
          b.tiltWrap.style.setProperty('--b-tilt-extra', tilt + 'deg');
        }
      });

      var n = stages.length || 1;
      var boundaries = [];
      if (n === 3) {
        boundaries = [0, 0.33, 0.85, 1];
      } else {
        for (var b = 0; b <= n; b++) boundaries.push(b / n);
      }
      var fadeFrac = 0.12;
      var lastEntryFrac = 0.3;
      stages.forEach(function (el, i) {
        var start = boundaries[i];
        var end = boundaries[i + 1];
        var segLen = end - start;
        var local = segLen > 0 ? (progress - start) / segLen : 0;
        var isLast = i === n - 1;
        var opacity = 0;

        if (local <= 0) {
          opacity = 0;
        } else if (isLast) {
          opacity = local < lastEntryFrac ? local / lastEntryFrac : 1;
        } else if (local >= 1) {
          opacity = 0;
        } else if (local < fadeFrac) {
          opacity = local / fadeFrac;
        } else if (local > 1 - fadeFrac) {
          opacity = (1 - local) / fadeFrac;
        } else {
          opacity = 1;
        }

        opacity = clamp(opacity, 0, 1);
        if (opacity !== el._lqOpacity) {
          el._lqOpacity = opacity;
          el.style.opacity = opacity;
          el.style.transform = 'translate3d(0,' + ((1 - opacity) * 20).toFixed(1) + 'px,0)';
        }
      });
    }

    function onScroll() {
      if (!isVisible || ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    var resizeTimer = null;
    function onResize() {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        // Ne reconstruit les filets que si la taille de la scène a vraiment changé
        // (pas à chaque apparition/disparition de la barre d'adresse sur mobile).
        var rect = sticky.getBoundingClientRect();
        if (Math.abs(rect.width - builtWidth) > 1 || Math.abs(rect.height - builtHeight) > 1) {
          buildStreams();
          streams.forEach(function (s) { s.lastOffset = null; });
        }
        update(true);
      }, 150);
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          isVisible = entry.isIntersecting;
          update(true);
        });
      }, { threshold: 0 });
      observer.observe(wrap);
    } else {
      isVisible = true;
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);

    var imgs = wrap.querySelectorAll('img');
    var pending = imgs.length;

    function onImagesReady() {
      buildStreams();
      update(true);
    }

    if (pending === 0) {
      onImagesReady();
    } else {
      imgs.forEach(function (img) {
        if (img.complete) {
          pending -= 1;
        } else {
          img.addEventListener('load', function () {
            pending -= 1;
            if (pending <= 0) onImagesReady();
          });
          img.addEventListener('error', function () {
            pending -= 1;
            if (pending <= 0) onImagesReady();
          });
        }
      });
      if (pending <= 0) {
        onImagesReady();
      } else {
        buildStreams();
        update(true);
      }
    }
  }

  function initAll() {
    document.querySelectorAll('[data-lq-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var el = event.target.querySelector('[data-lq-section]');
    if (el) initSection(el);
  });
})();
